
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/reference/4.6",
      function () {
        return require("private-next-pages/core-exchange/docs/reference/4.6/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/reference/4.6"])
      });
    }
  